import type { ReactNode } from "react";
import { Link } from "react-router";
import { Logo } from "@/components/Logo";
import { LangToggle } from "@/components/LangToggle";
import { ThemeToggle } from "@/components/ThemeToggle";
import { t } from "@shared/i18n";

export function AuthLayout({ title, subtitle, children, footer }: { title: string; subtitle?: ReactNode; children: ReactNode; footer?: ReactNode }) {
  return (
    <div className="grid min-h-dvh lg:grid-cols-[1fr_1.1fr]">
      <div className="pt-safe flex flex-col px-4 py-6 sm:px-10">
        <div className="flex items-center justify-between">
          <Link to="/" aria-label={t("Accueil GBC Coach IA")}>
            <Logo />
          </Link>
          <div className="flex items-center gap-1">
            <LangToggle />
            <ThemeToggle />
          </div>
        </div>
        <div className="animate-fade-up mx-auto flex w-full max-w-md flex-1 flex-col justify-center py-8">
          <div className="glass-card p-6 sm:p-8">
            <h1 className="text-[28px] font-bold leading-tight tracking-tight">{title}</h1>
            {subtitle && <p className="mt-2 text-[15px] text-muted">{subtitle}</p>}
            <div className="mt-7">{children}</div>
          </div>
          {footer && <div className="mt-6 text-center text-sm text-muted">{footer}</div>}
        </div>
        <p className="text-center text-[12px] text-subtle">© {new Date().getFullYear()} {t("GBC Coach IA · une application NeoTechRams")}</p>
      </div>
      <div className="relative hidden overflow-hidden lg:block">
        <div className="absolute inset-0 bg-[radial-gradient(55%_45%_at_75%_25%,color-mix(in_srgb,var(--brand)_22%,transparent),transparent_70%)]" />
        <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--border)_1px,transparent_1px),linear-gradient(to_bottom,var(--border)_1px,transparent_1px)] bg-[size:56px_56px] opacity-50 [mask-image:radial-gradient(70%_60%_at_50%_40%,black,transparent)]" />
        <div className="relative flex h-full flex-col justify-between p-14">
          <img src="/brand/logo.png" alt="" className="w-56 self-end opacity-95" />
          <div>
            <p className="text-[12px] font-semibold uppercase tracking-[0.16em] text-slate">{t("SmartCoachAI")}</p>
            <p className="mt-4 max-w-md text-[40px] font-bold leading-[1.05] tracking-tight">
              {t("Votre entreprise avance.")} <em className="text-primary">{t("Votre IA vous aide à garder une longueur d'avance.")}</em>
            </p>
            <div className="mt-10 flex items-center gap-3 text-sm text-muted">
              <span className="h-px w-10 bg-brand" /> {t("Coach IA · Planification · Finances · Documents")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
